import { ref, computed } from 'vue';
import camelcaseKeys from 'camelcase-keys';
import PromotionalCampaignsAPI from 'dashboard/api/promotionalCampaigns';

const queue = ref([]);
const hasFetched = ref(false);

export function usePromotionalCampaigns() {
  const currentCampaign = computed(() => queue.value[0] || null);

  const fetchEligibleCampaigns = async () => {
    if (hasFetched.value) return;
    hasFetched.value = true;
    try {
      const { data } = await PromotionalCampaignsAPI.get();
      queue.value = camelcaseKeys(data, { deep: true });
    } catch (error) {
      // Silently ignore, the modal simply won't show up.
    }
  };

  const logEvent = (campaignId, payload) => {
    PromotionalCampaignsAPI.logEvent(campaignId, payload).catch(() => {});
  };

  const dismissCurrentCampaign = () => {
    queue.value = queue.value.slice(1);
  };

  return {
    currentCampaign,
    fetchEligibleCampaigns,
    logEvent,
    dismissCurrentCampaign,
  };
}
